<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="main-card" v-if="fields.length > 0">
      <v-toolbar class="custom-toolbar ma-2" flat dense>
        <v-toolbar-title>Transport Information</v-toolbar-title>
      </v-toolbar>

      <v-row v-if="!is_valid" class="pb-7 font-weight-bold" justify="center" style="color: crimson;">
        {{ message }}
      </v-row>
      <v-row v-if="!is_editable" class="pb-7 font-weight-bold" justify="center" style="color: crimson;">
        {{ is_editable_message }}
      </v-row>

      <v-row class="px-5">
        <template v-for="field in fields">
          <v-col v-if="field.isactive" :key="field.field_name" :cols="field.input_type === 'textarea' ? 12 : 12"
            :sm="field.input_type === 'textarea' ? 12 : 3" :md="field.input_type === 'textarea' ? 12 : 3"
            class="pt-0 pb-0">
            <!-- Label -->
            <div v-if="field.input_type !== 'checkbox'" class="pl-1 pb-2" style="font-size: 14px;">
              <b>
                {{ field.label }}
                <span v-if="field.required" class="pl-1" style="color:red">*</span>
              </b>
            </div>

            <!-- TEXT & NUMBER FIELDS (with special logic for Aadhar & Contact) -->
            <v-text-field v-if="field.input_type === 'text' || field.input_type === 'number'" v-model.trim="field.value"
              :type="isRestrictedField(field.field_name) ? 'text' : (field.input_type === 'number' ? 'number' : 'text')"
              :inputmode="isRestrictedField(field.field_name) ? 'numeric' : undefined"
              :maxlength="getMaxLength(field.field_name)" @input="restrictDigitsOnly(field)"
              @keydown="blockExcessTyping($event, field)" @paste.prevent="handlePaste($event, field)"
              :counter="getMaxLength(field.field_name) || false" :rules="getValidationRules(field)"
              :hint="getHint(field.field_name)" persistent-hint dense outlined rounded
              :readonly="!field.iseditable || !is_valid || !is_editable"
              :filled="!field.iseditable || !is_valid || !is_editable" />

            <!-- TEXTAREA -->
            <v-textarea v-if="field.input_type === 'textarea'" v-model.trim="field.value"
              :readonly="!field.iseditable || !is_valid || !is_editable"
              :filled="!field.iseditable || !is_valid || !is_editable" dense outlined rounded />

            <!-- DATE -->
            <v-text-field v-if="field.input_type === 'date'" v-model.trim="field.value" type="date"
              :readonly="!field.iseditable || !is_valid || !is_editable"
              :filled="!field.iseditable || !is_valid || !is_editable" dense outlined rounded />

            <!-- CHECKBOX -->
            <div v-if="field.input_type === 'checkbox'" class="d-flex align-center pt-5">
              <v-checkbox v-model="field.value" :label="field.label"
                :readonly="!field.iseditable || !is_valid || !is_editable" density="compact" />
              <span v-if="field.required" class="pl-1" style="color:red">*</span>
            </div>

            <!-- SINGLE SELECT -->
            <v-select v-if="field.input_type === 'select' && !field.multiple" v-model="field.value" item-text="name"
              item-value="id" :items="field.options" :readonly="!field.iseditable || !is_valid || !is_editable"
              :filled="!field.iseditable || !is_valid || !is_editable" dense outlined rounded />

            <!-- MULTIPLE SELECT -->
            <v-autocomplete v-if="field.input_type === 'select' && field.multiple" v-model="field.value"
              :items="field.options" multiple :readonly="!field.iseditable || !is_valid || !is_editable"
              :filled="!field.iseditable || !is_valid || !is_editable" dense outlined rounded />
          </v-col>
        </template>
      </v-row>

      <v-col cols="12" align="center" class="pb-5">
        <v-btn text :disabled="!is_editable || !is_valid" class="button-77" @click="saveChildTransportDetails"
          :loading="save_loader">
          Save
        </v-btn>
      </v-col>
    </v-card>
  </div>
</template>

<script>
  import axios from "axios";

  export default {
    props: {
      learner: {
        type: [String, Number],
        required: true,
      },
    },

    data() {
      return {
        color: "",
        snackbar: false,
        snackbar_msg: "",
        message: "",
        is_valid: false,
        learner_id: "",
        fields: [],
        is_editable: false,
        is_editable_message: "",
        save_loader: false,
      };
    },

    watch: {
      learner(newVal) {
        if (newVal) this.getChildTransportDetails();
      },
    },

    methods: {
      // 1. कौन से fields पर strict limit है?
      isRestrictedField(fieldName) {
        return ["driver_aadhar_no", "driver_contact"].includes(fieldName);
      },

      // 2. Max length
      getMaxLength(fieldName) {
        if (fieldName === "driver_aadhar_no") return 12;
        if (fieldName === "driver_contact") return 10;
        return null;
      },


      getHint(fieldName) {
        if (fieldName === "driver_aadhar_no") return "Exactly 12 digits";
        if (fieldName === "driver_contact") return "Exactly 10 digits";
        return "";
      },


      restrictDigitsOnly(field) {
        if (!this.isRestrictedField(field.field_name)) return;

        let val = (field.value || "").replace(/\D/g, "");
        const max = this.getMaxLength(field.field_name);
        if (max) val = val.substring(0, max);

        if (field.value !== val) {
          this.$nextTick(() => (field.value = val));
        }
      },


      blockExcessTyping(e, field) {
        if (!this.isRestrictedField(field.field_name)) return;

        const max = this.getMaxLength(field.field_name);
        const current = (field.value || "").replace(/\D/g, "").length;

        if (current >= max) {
          const allowed = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End"];
          if (!allowed.includes(e.key) && !e.ctrlKey && !e.metaKey) {
            e.preventDefault();
          }
        }
      },


      handlePaste(e, field) {
        if (!this.isRestrictedField(field.field_name)) return;

        const pasted = (e.clipboardData || window.clipboardData).getData("text");
        const digits = pasted.replace(/\D/g, "").substring(0, this.getMaxLength(field.field_name));
        this.$nextTick(() => (field.value = digits));
      },


      getValidationRules(field) {
        if (!field.required && !field.value) return [];

        if (field.field_name === "driver_aadhar_no") {
          return [v => /^\d{12}$/.test(v || "") || "Aadhaar must be exactly 12 digits"];
        }
        if (field.field_name === "driver_contact") {
          return [v => /^\d{10}$/.test(v || "") || "Contact must be exactly 10 digits"];
        }
        return [v => !!v || `${field.label} is required`];
      },

      // तुमचे original methods
      getChildTransportDetails() {
        const data = { learner: this.learner };
        axios
          .post("/parent/getChildTransportDetails", data)
          .then((res) => {
            if (res.data.flag === "YES") {
              this.learner_id = res.data.learner_id;
              this.fields = res.data.fields;
              this.is_valid = res.data.is_valid;
              this.message = res.data.message;
              this.is_editable = res.data.is_editable;
              this.is_editable_message = res.data.is_editable_message;
            } else {
              this.showSnackbar("error", res.data.snackbar || "Something went wrong...");
            }
          })
          .catch(() => { })
          .finally(() => { });
      },

      saveChildTransportDetails() {
        // तुमचा original validation (अजूनही चालेल)
        for (let field of this.fields) {
          if (field.required && (!field.value || (Array.isArray(field.value) && field.value.length === 0))) {
            this.showSnackbar("error", `Please enter ${field.label}`);
            return;
          }
        }

        const fieldData = this.fields.reduce((obj, field) => {
          obj[field.field_name] = Array.isArray(field.value) ? field.value.join(",") : field.value;
          return obj;
        }, {});

        const payload = { learner_id: this.learner_id, ...fieldData };
        this.save_loader = true;

        axios
          .post("/parent/saveChildTransportDetails", payload)
          .then((res) => {
            if (res.data.flag === "YES") {
              this.showSnackbar("success", res.data.snackbar);
            } else {
              this.showSnackbar("error", res.data.snackbar);
            }
          })
          .catch(() => {
            this.showSnackbar("error", "Something went wrong!");
          })
          .finally(() => {
            this.save_loader = false;
          });
      },

      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
    },

    mounted() {
      this.getChildTransportDetails();
    },
  };
</script>

<style scoped>
  /* तुमचा original style येथे paste करा */
  .button-77 {
    color: #fff;
    cursor: pointer;
    font-weight: 800;
    vertical-align: middle;
    z-index: 0;
  }

  .button-77:before,
  .button-77:after {
    border-radius: 80px;
  }

  .button-77:before {
    background-color: rgba(249, 58, 19, 0.32);
    content: "";
  }

  .button-77:after {
    background-image: linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
    bottom: 4px;
    content: "";
    display: block;
    left: 4px;
    overflow: hidden;
    position: absolute;
    right: 4px;
    top: 4px;
    transition: all 100ms ease-out;
    z-index: -1;
  }

  .button-77:hover:not(:disabled):after {
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }

  .button-77:active:not(:disabled) {
    color: #ccc;
  }

  .button-77:active:not(:disabled):after {
    background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
      linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
    bottom: 4px;
    left: 4px;
    right: 4px;
    top: 4px;
  }

  .button-77:disabled {
    cursor: default;
    opacity: 0.24;
  }

  .main-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }

  .custom-toolbar {
    background: linear-gradient(to right, #a8edea, #e4d0ff);
  }
</style>